import React, { useEffect } from 'react';

import paperOSLogo from '../../assets/images/paperOS_wordmark_flat_md.png';
import stackIcon from '../../assets/images/icons/stack-icon.svg';
import syndicateIcon from '../../assets/images/icons/syndicate-icon.svg';
import piechartIcon from '../../assets/images/icons/piechart-icon.svg';
import searchIcon from '../../assets/images/icons/search-icon.svg';
import scalesIcon from '../../assets/images/icons/scales-icon.svg';
// import chevronRightIcon from '../../assets/images/icons/chevron-right-icon.svg';

import heroExample from '../../assets/images/examples/funds__hero--portal.png';
import fundraisingExample from '../../assets/images/examples/funds__fundraising-library.png';
import closingExample from '../../assets/images/examples/funds__closing-funds.png';
import reportingExample from '../../assets/images/examples/funds__reporting.png';
import investmentsExample from '../../assets/images/examples/funds__investments-deal-room.png';
import distributionsExample from '../../assets/images/examples/funds__distributions-portfolio.png';
// import { SperoFund } from '../../components/PaperOSBranding/PaperOSBranding';

import {
  Button,
  Footer,
  FloatingList,
  Sitemap,
  Topbar,
  MetricsList,
} from '../../components/common';

import { generateBem } from '../../utils/generateBem';
import './Spero.scss';

const bem = generateBem('Spero');

const solutionsList = [
  {
    icon: stackIcon,
    iconClassName: bem('floatingIcon'),
    // image: reportsExample,
    image: [fundraisingExample],
    imageClassName: bem(['sectionItemImage--shadow']),
    title: 'Fund Admin SaaS',
    description:
      'Our software streamlines fund management from onboarding to reporting. It delivers unique insights, reduces manual work, and improves accuracy across every operation.',
  },
  {
    icon: syndicateIcon,
    // iconClassName: bem('floatingIcon'),
    // image: portalExample,
    image: closingExample,
    imageClassName: bem(['sectionItemImage--shadow']),
    title: 'Administration Services',
    description:
      'We deliver comprehensive solutions for managing your fund’s daily operations — from investor onboarding to performance tracking. Our team ensures seamless processes, accuracy, and efficiency at every stage.',
  },
  {
    icon: searchIcon,
    iconClassName: bem('floatingIcon'),
    // image: projectsExample,
    image: reportingExample,
    imageClassName: bem(['sectionItemImage--shadow']),
    title: 'Accounting & Reporting',
    description:
      'We provide precise, timely financial reporting tailored to your fund’s needs. Investor-ready statements and performance insights keep you transparent and compliant.',
  },
  {
    icon: scalesIcon,
    iconClassName: bem('floatingIcon'),
    // image: docsExample,
    image: investmentsExample,
    imageClassName: bem(['sectionItemImage--shadow']),
    title: 'Fund Compliance',
    // longTitle: 'Investment Deals & Diligence',
    description:
      'We oversee and streamline your fund’s compliance requirements with proactive, detail-oriented management. Our process minimizes risk and ensures you stay aligned with evolving regulations.',
  },
  {
    icon: piechartIcon,
    // image: portalExample,
    image: distributionsExample,
    imageClassName: bem(['sectionItemImage--shadow']),
    iconClassName: bem('floatingIcon'),
    title: 'Fractional Fund CFO',
    description:
      'Access the expertise of a seasoned CFO without the full-time cost. We offer strategic oversight, forecasting, and financial leadership to guide growth and investor confidence.',
  },
];

// const pricingList = [
//   {
//     buttonHref: 'https://share.hsforms.com/13LANhGXnQYeJrK3F44-_JA2rvzm',
//     buttonText: 'Get Started',
//     colHeader: 'Fund Formations',
//     list: [
//       'Formation Services (Any Structure)',
//       'Automated Formations',
//       'Counsel & Drafting',
//       'Standard Documents',
//       'LPA & PPM Drafting*',
//       'Banking Setup',
//       'Data Rooms & NDAs',
//       'LP Portal & Deal Rooms',
//       'Subscription Agreements',
//       'LP Compliance (KYC/AML)',
//       'Form D / Blue Sky Filings',
//     ],
//     additionalInfoLabel: 'Full-Service Formation Quote',
//     isHref: true,
//     additionalInfoLink: 'https://share.hsforms.com/13LANhGXnQYeJrK3F44-_JA2rvzm',
//     prePrice: 'Pricing varies by Fund Type',
//     // price: '$499',
//     // postPrice: 'per year',
//     footerList: ['*via the PaperOS Partner Network'],
//   },
//   {
//     buttonHref: 'https://share.hsforms.com/13LANhGXnQYeJrK3F44-_JA2rvzm',
//     buttonText: 'Request a Quote',
//     colHeader: 'Fund Administration',
//     list: [
//       'Formation Support',
//       'Closing Coordination',
//       'Compliance Coordination',
//       'Capital Calls & Distributions',
//       'Reporting & Accounting',
//       'Taxes & Audits',
//       'Investments & Valuations',
//       'End-of-Life Services',
//       'Self-Administration Support',
//     ],
//     additionalInfoLabel: 'Learn More',
//     additionalInfoLink: '/capital-management/fund-administration',
//     prePrice: 'Pricing varies by Fund Type',
//   },
//   {
//     buttonHref: 'https://share.hsforms.com/13LANhGXnQYeJrK3F44-_JA2rvzm',
//     buttonText: 'Contact Sales',
//     colHeader: 'Fund Platform',
//     list: [
//       'Fund Workflow Automation',
//       'Standard / Custom Structures',
//       'Multi-Fund Portfolios',
//       'Integrated LP Portals',
//       'Reporting Automation',
//       'Investment Documents',
//       'Diligence Checklists',
//       'Custom Branding',
//       'Partner Network Add-ons',
//       'CRM & Banking Integrations',
//     ],
//     additionalInfoLabel: 'Additional Platform Features',
//     additionalInfoLink: '/plans',
//     prePrice: 'Flexible Platform Plans',
//   },
// ];

const Spero = ({ location: { search } }) => {
  useEffect(() => {
    document.title = 'Fund Management Solutions | PaperOS';
  }, []);

  return (
    <>
      <Topbar />
      <section className={`${bem('heroSection')} container`}>
        <div className="row">
          <div className={bem('heroColumn')}>
            <div className={bem('heroTextWrapper')}>
              <h1 className={bem('heroHeading')}>
                Comprehensive
                <br />
                Fund Admin Solutions
              </h1>
              <h3 className={bem('heroSubtext')}>
                One partner for managing all fund administration services.
              </h3>
            </div>
            <div className={bem('heroButtonWrapper')}>
              <Button
                className={bem('heroButton')}
                isFlat
                href="https://share.hsforms.com/13LANhGXnQYeJrK3F44-_JA2rvzm"
              >
                Talk to Sales
              </Button>
              <h3 className={bem('heroPartnerText')}>
                In partnership with
                <img
                  className={bem('heroPartnerLogo')}
                  src={paperOSLogo}
                  alt="PaperOS Logo"
                />
              </h3>
            </div>
          </div>
          <div className={bem('heroImageWrapper')}>
            <img
              className={bem('heroImage')}
              src={heroExample}
              alt="Paperos Investors Page Example"
            />
            <div className={bem('floatingList')}>
              <FloatingList items={solutionsList} zIndex="80" />
            </div>
          </div>
        </div>
      </section>
      <section className="container container--light">
        <div className="row">
          <MetricsList metricType="funds" />
        </div>
      </section>
      <div className={bem('section')}>
        {solutionsList.map(
          (
            { description, image, imageClassName, title, longTitle, icon },
            solutionIndex,
          ) => {
            const isEven = (solutionIndex + 1) % 2;
            return (
              !!description && (
                <section
                  key={`solution-${title}`}
                  className={bem(['sectionRow', isEven ? 'sectionRow--even' : null])}
                >
                  <div
                    className={bem([
                      'sectionItem',
                      isEven ? 'sectionItem--rightPadding' : 'sectionItem--leftPadding',
                    ])}
                  >
                    <div className={bem('sectionItemRow')}>
                      <img
                        className={bem('sectionItemIcon')}
                        src={icon}
                        alt={`${title} icon`}
                      />
                      <h2>{longTitle || title}</h2>
                    </div>
                    <div className={bem('sectionItemRow')}>
                      <p>{description}</p>
                    </div>
                  </div>
                  <div className={bem(['sectionItem', 'sectionItem--image'])}>
                    <img
                      className={`${bem('sectionItemImage')} ${imageClassName || ''}`}
                      src={image}
                      alt={`${title} Example UI`}
                    />
                  </div>
                </section>
              )
            );
          },
        )}
      </div>
      {/* <section className="container container--light">
        <div className={`${bem(['section', 'section--pricing'])}`}>
          <div className={bem('getStarted')}>
            <p>Get started with</p>
            {SperoFund()}
          </div>
          {pricingList.map(
            (
              {
                additionalInfoLabel,
                additionalInfoLink,
                isHref,
                buttonHref,
                buttonText,
                colHeader,
                isSearchAdded,
                list,
                prePrice,
                price,
                postPrice,
                footerList = [],
              },
              pricingCardIndex,
            ) => (
              <div
                key={`pricing-list-item-${colHeader}`}
                className={bem([
                  'pricingCard',
                  (pricingCardIndex + 1) % 2 ? null : 'pricingCard--even',
                ])}
              >
                <div className={bem('pricingCardList')}>
                  <h4>{colHeader}</h4>
                  <ul>
                    {list.map(item => (
                      <li key={`price-item-${item}`}>{item}</li>
                    ))}
                    {!!additionalInfoLink && !!isHref && (
                      <Button buttonType="link" size="sm" href={additionalInfoLink}>
                        {additionalInfoLabel}
                        <img src={chevronRightIcon} alt={'chevron right icon'} />
                      </Button>
                    )}
                    {!!additionalInfoLink && !isHref && (
                      <Button buttonType="link" size="sm" to={additionalInfoLink}>
                        {additionalInfoLabel}
                        <img src={chevronRightIcon} alt={'chevron right icon'} />
                      </Button>
                    )}
                  </ul>
                </div>
                <div className={bem('pricingCardBottom')}>
                  <div className={bem('pricingCardPrePrice')}>{prePrice}</div>
                  <div className={bem('pricingCardPrice')}>
                    {!!price && <h2>{price}</h2>}
                    <p className={bem('pricingCardPostPrice')}>{postPrice}</p>
                  </div>
                  <Button
                    className={bem('pricingCardAction')}
                    href={`${buttonHref}${isSearchAdded ? search : ''}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {buttonText}
                  </Button>
                  <div className={bem('pricingCardFooter')}>
                    {footerList.map(footer => (
                      <h4 key={`price-footer-${footer}`}>{footer}</h4>
                    ))}
                  </div>
                </div>
              </div>
            ),
          )}
        </div>
      </section> */}
      <Sitemap />
      <Footer />
    </>
  );
};

export default Spero;
